<div class="cnt-page-internal">
    <div class="row-title">
        <!-- <teiasoft-title [title]="'costingTool.title' | translate"></teiasoft-title> -->
        <teiasoft-title [title]="'viewMasterdata.title' | translate"></teiasoft-title>
        <div class="cnt-toolbar">
            <!-- <span class="span-select mr-5">{{'viewMasterdata.selectMasterdata' | translate}}:</span> -->
            <div class="cnt-selection mr-5" [ngClass]="{'active' : selected == 'normgrades'}"
                (click)="onSelectThis('normgrades')">

                <span>{{'viewMasterdata.normGrades' | translate}}</span>
            </div>

            <div class="cnt-selection mr-5" [ngClass]="{'active' : selected == 'raw'}" (click)="onSelectThis('raw')">

                <span>{{'viewMasterdata.rawMaterialGrades' | translate}}</span>
            </div>

            <div class="cnt-selection mr-5" [ngClass]="{'active' : selected == 'customers'}"
                (click)="onSelectThis('customers')">

                <span>{{'viewMasterdata.customers' | translate}}</span>
            </div>

            <div class="cnt-selection" [ngClass]="{'active' : selected == 'sms'}" (click)="onSelectThis('sms')">
                <span>{{'viewMasterdata.sms' | translate}}</span>
            </div>
        </div>
    </div>
    <!-- TOOLBAR -->
    <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
        style="width: 100%;"></teiasoft-toolbar>

    <!-- *ngIf="showOdataGrid" -->
    <teiasoft-grid-odata [ngStyle]="{'visibility': showOdataGrid ? 'visible' : 'hidden'}" [columnsToHideGOD]="columnsToHide" [oDataUrl]="oDataUrl"
        [odataEntity]="oDataEntity" [sortable]="true" [theme]="globals.theme!" style="width:100%"
        [disableAllSelection]="true" [filterable]="gridFilterable" [clearFilters]="clearFilters"
        [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!"
        [gridConfiguration]="gridConfiguration" (onUpdateConfiguration)="onUpdateConfiguration($event)"
        [autoWidth]="true" [refreshGridKey]="refreshGridKey" [selectable]="false" [multiSelection]="false" [paginable]="true"
        [rowsPerPage]="100" [filtersToHide]="filtersToHide" [columnsWidth]="columnsWidth"
        (onActiveFiltersUpdate)="onActiveFiltersUpdate($event)" [resizableColumnRedistribute]="true" [roundDigits]="roundDigits">
    </teiasoft-grid-odata>
</div>